import React, { useState, useEffect } from 'react';
import HeroIntro from './HeroIntro';

interface IntroWrapperProps {
  children: React.ReactNode;
  enableIntro?: boolean;
}

const IntroWrapper: React.FC<IntroWrapperProps> = ({ 
  children, 
  enableIntro = true 
}) => {
  const [showIntro, setShowIntro] = useState(false);
  const [introComplete, setIntroComplete] = useState(false);

  useEffect(() => {
    if (!enableIntro) {
      setIntroComplete(true);
      return;
    }

    // Always show intro on homepage - remove session storage check
    const urlParams = new URLSearchParams(window.location.search);
    const resetIntro = urlParams.get('resetIntro') === '1';
    
    // Show intro every time on homepage (/)
    const isHomepage = window.location.pathname === '/';
    
    if (isHomepage || resetIntro) {
      // Small delay to ensure page is loaded
      const timer = setTimeout(() => {
        setShowIntro(true);
      }, 200);
      
      return () => clearTimeout(timer);
    } else {
      setIntroComplete(true);
    }
  }, [enableIntro]);

  const handleIntroComplete = () => {
    setShowIntro(false);
    setIntroComplete(true);
    // No longer save to session storage - intro shows every time on homepage
  };

  if (!enableIntro || introComplete) {
    return <>{children}</>;
  }

  return (
    <>
      {showIntro && (
        <HeroIntro 
          onComplete={handleIntroComplete}
          canSkip={true}
        />
      )}
      {children}
    </>
  );
};

export default IntroWrapper;